'use client'

import {
  Container,
  HStack,
  SimpleGrid,
  Skeleton,
  Stack,
  Text,
} from '@chakra-ui/react'
import React from 'react'
import SkeletonCard from '../_components/Skeleton/Card'
import { SkeletonCircle, SkeletonText } from '@/components/ui/skeleton'

function Loading({ text = 'Server loading...' }: { text: string }) {
  return (
    <Container px={{ base: 4, lg: 10 }}>
      <HStack
        display={{ base: 'flex', lg: 'none' }}
        justifyContent={'space-between'}
        pt={4}
      >
        <HStack width='full' gap={4}>
          <Skeleton w='48px' height='48px' rounded={12} />
          <Stack flex={1} gap={1}>
            <SkeletonText noOfLines={1} w={'150px'} />
            <SkeletonText noOfLines={1} w={'180px'} />
          </Stack>
        </HStack>
        <HStack>
          <SkeletonCircle size='8' />
          <SkeletonCircle size='8' />
        </HStack>
      </HStack>
      <HStack
        display={{ base: 'none', lg: 'flex' }}
        justifyContent={'space-between'}
        pt={4}
      >
        <HStack width='full' gap={4}>
          <Stack>
            <Skeleton w={'30px'} height='4px' rounded={8} />
            <Skeleton w={'30px'} height='4px' rounded={8} />
            <Skeleton w={'30px'} height='4px' rounded={8} />
          </Stack>

          <HStack>
            <Skeleton w={'48px'} height='48px' rounded={'full'} />
            <Skeleton w={'190px'} height='30px' />
          </HStack>
          <HStack w={'260px'} height='48px' bg={'light.200'} p={1} rounded={16}>
            <Skeleton w={'120px'} height='40px' rounded={12} m={1} />
          </HStack>
          <Skeleton w={'190px'} height='48px' rounded={16} />
        </HStack>
        <HStack>
          <Skeleton w={'48px'} height='48px' rounded={16} />
          <Skeleton w={'108px'} height='48px' rounded={16} />
          <Skeleton w={'150px'} height='48px' rounded={16} />
          <Skeleton w={'48px'} height='48px' rounded={16} />
        </HStack>
      </HStack>
      <HStack
        display={{ base: 'flex', lg: 'none' }}
        justify={'space-between'}
        align={'center'}
        mt={3}
      >
        <Stack gap={1}>
          <SkeletonText noOfLines={1} w={'70px'} />
          <SkeletonText noOfLines={1} w={'150px'} />
        </Stack>
        <Skeleton w='132px' height='40px' rounded={12} />
      </HStack>
      <HStack w={'full'} mt={{ base: 4, lg: 6 }}>
        <Skeleton
          w={'full'}
          rounded={{ base: 16, lg: 64 }}
          height={{ base: '220px', lg: '440px' }}
        />
      </HStack>
      <HStack
        gap={'21px'}
        flexWrap={'wrap'}
        w={'full'}
        mt={6}
        display={{ base: 'none', lg: 'flex' }}
      >
        <Skeleton w={'141px'} height='56px' rounded={16} />
        {Array.from({ length: 15 }).map((_, idx) => {
          const widths = ['100px', '120px', '154px', '90px', '132px']
          const randomWidth = widths[Math.floor(Math.random() * widths.length)]

          return (
            <Skeleton key={idx} w={randomWidth} height='56px' rounded={16} />
          )
        })}
      </HStack>
      <HStack
        overflow={'scroll'}
        scrollbar={'hidden'}
        w={'full'}
        gap={4}
        mt={4}
        display={{ base: 'flex', lg: 'none' }}
      >
        <Skeleton w={'56px'} height='56px' rounded={16} />
        <Skeleton w={'56px'} height='56px' rounded={16} />
        <Skeleton w={'56px'} height='56px' rounded={16} />
        <Skeleton w={'56px'} height='56px' rounded={16} />
        <Skeleton w={'56px'} height='56px' rounded={16} />
        <Skeleton w={'56px'} height='56px' rounded={16} />
      </HStack>

      <SkeletonText
        noOfLines={1}
        w='150px'
        height='20px'
        mt={{ base: 8, lg: 6 }}
      />
      <SimpleGrid
        py={4}
        gap={{ base: 3, lg: 4 }}
        columns={{ base: 2, md: 3, lg: 4 }}
      >
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </SimpleGrid>
      <Text textAlign='center' color='gray'>
        {text}
      </Text>
    </Container>
  )
}

export default Loading
